export default __webpack_public_path__ + "static/media/go-to-test-image-person.5ecdea4e.svg";